import React, { useContext } from 'react';
import { ButtonAccentPrimary, ButtonCta, ButtonPrimary, ButtonSecondary } from '@components/button';
import { FeatureFlagContext } from '@contexts/featureFlag/featureFlag-context';
import classNames from 'classnames';

import { ModalStickyFooterProps } from './modal-sticky-footer.type';

export const ModalStickyFooter = ({
  isAccent,
  isSubmit,
  isSubmitDisabled,
  isSecondaryButtonDisabled,
  primaryButtonText,
  secondaryButtonText,
  tertiaryButtonText,
  primaryDataTestId,
  secondaryDataTestId,
  tertiaryDataTestId,
  tertiaryIcon,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onTertiaryButtonClick,
}: ModalStickyFooterProps) => {
  const { isWebView } = useContext(FeatureFlagContext);
  const alignClasses = {
    'justify-between': onTertiaryButtonClick,
    'items-center justify-end': onSecondaryButtonClick && (onPrimaryButtonClick || isSubmit) && !onTertiaryButtonClick,
    'justify-end': !onSecondaryButtonClick && (onPrimaryButtonClick || isSubmit) && !onTertiaryButtonClick,
  };

  const ButtonPrimaryComponent = isAccent ? ButtonAccentPrimary : ButtonPrimary;

  const GroupedButtons = () => (
    <>
      {onSecondaryButtonClick && (
        <ButtonSecondary
          data-testid={secondaryDataTestId}
          onClick={onSecondaryButtonClick}
          disabled={isSecondaryButtonDisabled}>
          {secondaryButtonText}
        </ButtonSecondary>
      )}
      {isSubmit && (
        <ButtonPrimaryComponent data-testid={primaryDataTestId} type='submit' disabled={isSubmitDisabled}>
          {primaryButtonText}
        </ButtonPrimaryComponent>
      )}
      {!isSubmit && onPrimaryButtonClick && (
        <ButtonPrimaryComponent
          data-testid={primaryDataTestId}
          onClick={onPrimaryButtonClick}
          disabled={isSubmitDisabled}>
          {primaryButtonText}
        </ButtonPrimaryComponent>
      )}
    </>
  );

  const TertiaryButton = () => (
    <ButtonCta
      data-testid={tertiaryDataTestId}
      onClick={onTertiaryButtonClick}
      className={classNames('text-body-s md:text-body-m', { 'text-accent': isAccent, 'text-primary': !isAccent })}
      paddingClasses='p-0'>
      {tertiaryIcon ? (
        <div className='flex gap-2 items-center'>
          {tertiaryIcon} {tertiaryButtonText}
        </div>
      ) : (
        tertiaryButtonText
      )}
    </ButtonCta>
  );

  return (
    <footer
      className={classNames(
        'sticky bottom-0 flex flex-wrap gap-3 sm:gap-6 w-full bg-primary shadow-custom px-7 ',
        {
          'py-5': isWebView,
          'pt-5 pb-2 xs:pb-5': !isWebView,
        },
        alignClasses
      )}>
      {onTertiaryButtonClick ? (
        <>
          <TertiaryButton />
          <div className='ml-auto flex gap-3 sm:gap-6'>
            <GroupedButtons />
          </div>
        </>
      ) : (
        <GroupedButtons />
      )}
    </footer>
  );
};
